import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper'

class PsFooter extends Component {
    render() {
        return (
            <div >
                <a href='' onClick={onUnsubClick} target="_blank">الغاء الاشتراك</a>
            </div>
        );
    }
}

export default PsFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/psfooter.js